module.exports = __webpack_public_path__ + "static/media/23-10.1c4267a3.mp3";